import { amWindow } from "../types";

const gainsight = {
  identify: async (params: any) => {
    // This is used to identify a unique user, across various tracking vendors
    if (amWindow.aptrinsic && params) {
      amWindow.aptrinsic("identify", params);
    }
  },

  reset: () => {
    if (amWindow.aptrinsic) {
      amWindow.aptrinsic("reset");
    }
  },

  track: (name: string, params?: any) => {
    if (amWindow.aptrinsic) {
      amWindow.aptrinsic("track", name, params);
    }
  },

  globalContext: (type, params) => {
    // types are 'set', 'setOnce', 'remove' //
    if (amWindow.aptrinsic) {
      amWindow.aptrinsic(type, "globalContext", params);
    }
  },
};

export default gainsight;
